import { buildOrderListColumns } from '@ldt/features/orders/order_list/shared';
import type { OrderListSearchConfig } from 'src/distribution_platforms/features/order_list';
import type { WorkflowDefinition } from 'src/distribution_platforms/features/workflow_definition';

export const orderListSearchConfig: OrderListSearchConfig = {
  placeholder: 'Search by Order ID, Patient, or Physician Name',
  width: '400px',
};

export function getOrderListColumns(workflow: WorkflowDefinition) {
  return buildOrderListColumns(workflow);
}
